import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { post } from "../../controllers/apiController";
import Layout from "../../components/Layout";
import { Select2 } from "../../components/Select2";

const CustomerCreate = () => {
    const [customerName, setCustomerName] = useState(null);
    const [companyName, setCompanyName] = useState(null);
    const [customerEmail, setCustomerEmail] = useState(null);
    const [customerPhone, setCustomerPhone] = useState(null);
    const [source, setSource] = useState(null);

    const sources = [
        { value: "Meta", label: "Meta" },
        { value: "Manuel", label: "Manuel" },
        { value: "Ads", label: "Ads" },
        { value: "Landing Page", label: "Landing Page" },
        { value: "WordPress", label: "WordPress" },
        { value: "Referans", label: "Referans" },
        { value: "Instagram", label: "Instagram" }
    ];

    useEffect(() => {
        document.title = "Müşteri Ekle | LEVELUP CRM";
    }, []);

    const createCustomer = async () => {
        if (!source) {
            toast.error("Kaynağı girmelisiniz!");
            return;
        }

        try {
            const response = await post("forms/create-customer", {
                nameSurname: customerName,
                companyName: null,
                source: source.value,
                email: customerEmail,
                phone: customerPhone
            });

            setCustomerName(null);
            setCustomerEmail(null);
            setCustomerPhone(null);
            setSource(null);

            toast.success("Müşteri başarıyla eklendi!");
        } catch (err) {
            toast.error("Müşteri oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Manuel Müşteri Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Müşteri Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerName" className="fw-semibold">Adı Soyadı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-user"></i></div>
                                                    <input type="text" className="form-control" id="customerName" placeholder="Müşterinin adını soyadını giriniz." onChange={(e) => setCustomerName(e.target.value)} value={customerName} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerEmail" className="fw-semibold">E-Posta Adresi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-mail"></i></div>
                                                    <input type="text" className="form-control" id="customerEmail" placeholder="Müşteri e-posta adresini giriniz." onChange={(e) => setCustomerEmail(e.target.value)} value={customerEmail} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="customerPhone" className="fw-semibold">Telefon Numarası: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-phone"></i></div>
                                                    <input type="text" className="form-control" id="customerPhone" placeholder="Telefon numarasını başına 0 ekleyerek yazınız." onChange={(e) => setCustomerPhone(e.target.value)} value={customerPhone} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="customerPhone" className="fw-semibold">Kaynak: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-globe"></i></div>
                                                    <div style={{ flex: 1 }}>
                                                        <Select2
                                                            value={source}
                                                            key={"sourceSelect"}
                                                            options={sources}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            isMulti={false}
                                                            onChange={(e) => setSource(e)}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createCustomer} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Müşteri Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
}

export default CustomerCreate;